import { Button, Col, Form, Row } from "antd";
import { FC, useEffect, useState } from "react";
import styled from "@emotion/styled";
import VariationOptionCard from "./VariationOptionCard";
import { v4 as uuidv4 } from "uuid";
import VariationPriceForm from "./VariationPriceForm";
import _ from "lodash";
import { backendUrl } from "config";

interface ProductVariationCreateProps {
  setVariants: (variants: VariantsInput) => void;
  variants: VariantsInput;
  setPrices: (prices: PricesInput) => void;
  prices: PricesInput;
  onClose: () => void;
  is_guid: boolean;
  is_inventory: boolean;
}

const ProductVariationCreate: FC<ProductVariationCreateProps> = ({
  setVariants,
  setPrices,
  onClose,
  variants,
  prices,
  is_guid,
  is_inventory,
}) => {
  const [form] = Form.useForm();
  const [skuItems, setSkuItems] = useState<VariationData[]>([]);
  const [skuPrice, setSkuPrice] = useState<VariationPrice[]>([]);
  const [formValidate, setFormValidate] = useState<boolean>(true);

  const onFinish = (values: any) => {

    console.log("values sku form", values);

    if (!_.isEmpty(values.sku_items)) {
      const skuItemId = values.sku_items.map((item: any) => {
        return {
          name: item.name,
          items: item.items.map((option: any) => {
            return {
              name: option.name,
              image_id: option.image_id ? option.image_id?.[0].id : "",
              id: option.id || uuidv4(),
              product_capacity : parseInt(option.product_capacity) || 0,
              product_sku_code: option.product_sku_code || "",
              expire_date_amount: parseInt(option.expire_date_amount) || 0,
            };
          }),
          id: item.id || uuidv4(),
 
        };
      });

      console.log("skuItemId ??", skuItemId);

      setSkuItems(skuItemId);

      const skuPriceGen = convertSkuItemToSkuPrice(skuItemId, prices);

      setSkuPrice(skuPriceGen);
    }
  };

  //convert sku VariationData to skuPrice
  const convertSkuItemToSkuPrice = (skuItems: VariationData[], prices?: PricesInput ) => {
    const skuPrice: VariationPrice[] = [];

    if(prices){
      skuItems.forEach((item1) => {
        item1.items.forEach((item2) => {
          const price = prices.find((price) => {
            return price.variant_1_item_id === item2.id;
          });
          skuPrice.push({
            name: `${item1.name}: ${item2.name}`,
            variant_1_item_id: item2.id,
            variant_2_item_id: "",
            factory_price: price?.factory_price || 0,
            wholesale_price: price?.wholesale_price || 0,
            retail_price: price?.retail_price || 0,
          });
        });
      });
      
    } else {
    
    // 1. สร้าง skuPrice จาก skuItems แบบ 2 ระดับ
    if (skuItems.length === 2) {
      skuItems[0].items.forEach((item1) => {
        skuItems[1].items.forEach((item2) => {
          skuPrice.push({
            name: `${skuItems[0].name}: ${item1.name} ${skuItems[1].name}: ${item2.name}`,
            variant_1_item_id: item1.id,
            variant_2_item_id: item2?.id || "",
            factory_price: 0,
            wholesale_price: 0,
            retail_price: 0,
          });
        });
      });
    } else if (skuItems.length === 1) {
      skuItems[0].items.forEach((item1) => {
        skuPrice.push({
          name: `${skuItems[0].name}: ${item1.name}`,
          variant_1_item_id: item1.id,
          variant_2_item_id: "",
          factory_price: 0,
          wholesale_price: 0,
          retail_price: 0,
        });
      });
    }

  }

    return skuPrice;
  };

  const onResetSkuPrice = () => {
    setSkuPrice([]);
  };

  const onFinishSkuPrice = () => {
    if(formValidate === false){
      return;
    }
    // skuPrice remove name field

    const newSkuPrice = skuPrice.map((item) => {
      return {
        variant_1_item_id: item.variant_1_item_id,
        variant_2_item_id: item.variant_2_item_id,
        factory_price: item.factory_price,
        wholesale_price: item.wholesale_price,
        retail_price: item.retail_price,
      };
    });

    console.log("กำหนด==>skuItems", skuItems);

    setPrices(newSkuPrice);
    setVariants(skuItems);
    onClose();

  };


  
  const onSkuPriceChange = (values: VariationPrice) => {
    // update value skuUpdatePrice with skuPrice

    const skuPriceUpdate = skuPrice.map((item) => {
      if (
        item.variant_1_item_id === values.variant_1_item_id &&
        item.variant_2_item_id === values.variant_2_item_id
      ) {
        return {
          ...item,
          factory_price: values.factory_price,
          wholesale_price: values.wholesale_price,
          retail_price: values.retail_price,
        };
      }

      return item;
    });

    setSkuPrice(skuPriceUpdate);

  };

  const onSetValidate = (value: boolean) => {
    setFormValidate(value);
  };

  useEffect(() => {
    if (variants.length > 0 && prices.length > 0) {
      // re name image_url to url 
      const newSkuItems = variants.map((item) => {
        return {
          ...item,
          items: item.items.map((option) => {
            let imageArray: any[] = [];
            if (option.image_id) {
              imageArray = [{
                id: option.image_id,
                url: `${backendUrl}images/${option.image_id}` ,
                name : option.name
              }]
            }
            const imageUrl = option.image_id ? `${backendUrl}images/${option.image_id}` : '';
            return {
              ...option,
              image_id:imageArray,
            };
          }),
        };
      });

     // console.log("skuItems", newSkuItems);

      form.setFieldsValue({
        sku_items: newSkuItems,
      });

      setSkuItems(variants);


      const skuPriceGen = convertSkuItemToSkuPrice(variants, prices);

      setSkuPrice(skuPriceGen);
      
     // setFormValidate(true)

    }
  }, [variants, prices]);

  return (
    <>
      {skuPrice.length > 0 ? (
        <>
          <Row gutter={[8, 8]} style={{ width: "100%", height: "75vh", overflow: "auto" }}>
            {skuPrice.map((item) => {
              return (
                <Col xs={{ span: 24 }} md={{ span: 12 }}  >
                  <VariationPriceForm
                    key={item.name}
                    data={item}
                    onSetValidate={onSetValidate}
                    onSkuPriceChange={onSkuPriceChange}
                    prices={prices}
                  />
                </Col>
              );
            })}
          </Row>
          <WrapperPriceButton>
            <Button type="default" htmlType="button" onClick={onResetSkuPrice} style={{ width: 100 }} >
              กลับ
            </Button>

            <Button
              type="primary"
              htmlType="submit"
              onClick={onFinishSkuPrice}
              style={{ width: 200 }}
              disabled={!formValidate || is_inventory === true}
            >
              บัททึก
            </Button>
          </WrapperPriceButton>
        </>
      ) : (
        <>
          <Form form={form} onFinish={onFinish} className="form-variation">
            <Wrapper>
              <FormWrapper>
                <VariationOptionCard form={form} skuItems={skuItems} variants={variants} is_guid={is_guid} is_inventory={is_inventory} />
              </FormWrapper>
            </Wrapper>
            <ButtonWrapper>
              <Button
                type="primary"
                htmlType="submit"
                onClick={onFinish}
                style={{ width: 300 }}
                disabled={form.getFieldValue("sku_items")?.length === 0}
              >
                กำหนดราคา
              </Button>
            </ButtonWrapper>
          </Form>
        </>
      )}
    </>
  );
};

export default ProductVariationCreate;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 16px;
`;

const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  margin-top: 16px;
  height: 80vh;
  overflow-y: auto;
`;

const WrapperPriceButton = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  margin-top: 16px;
  align-items: center;
`;
